import AuthenticationRoutes from "./authentication";
import BlankLayout from "@layouts/types/blank-layout";
import { Fragment } from "react";
import LayoutWrapper from "@layouts/components/layout-wrapper";
import PanelRoutes from "./panel";
import PrivateRoute from "../private-route";
import PublicRoute from "../public-route";
// TEMPORARY — internal superadmin console; delete this import and the spread
// below (plus src/router/routes/superadmin.jsx and src/views/superadmin/).
import SuperadminRoutes from "./superadmin";
import VerticalLayout from "@layouts/types/vertical-layout";
import size from "lodash/size";
import { getItemFromStore } from "@src/utility/helpers/utils";

// Where each role's workspace starts — bare `/brand` and `/publisher` resolve
// to the active brand/publisher via their own index-redirect once the topbar
// switcher's list has loaded.
export const ROLE_HOME_ROUTE = {
  ops      : "/dashboard",
  brand    : "/brand",
  publisher: "/publisher"
};

export const getPanelDefaultRoute = () => {
  const userInfo = getItemFromStore("userInfo") || {};
  const role = userInfo.user?.role;
  return ROLE_HOME_ROUTE[role] || "/dashboard";
};

// ** Merge Routes
const Routes = [...AuthenticationRoutes, ...PanelRoutes, ...SuperadminRoutes];

const getRouteMeta = (route) => {
  if (!size(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta };
    } else {
      return {};
    }
  }
};

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = [];

  if (Routes) {
    Routes.filter((route) => {
      let isBlank = false;
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) &&
          defaultLayout === layout)
      ) {
        let RouteTag = PrivateRoute;
        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === "blank" ? (isBlank = true) : (isBlank = false);
          RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute;
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            !size(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
                LayoutWrapper
              : Fragment;
          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          );
        }
        // Push route to LayoutRoutes
        LayoutRoutes.push(route);
      }
      return LayoutRoutes;
    });
  }
  return LayoutRoutes;
};
const getLayout = {
  blank   : <BlankLayout />,
  vertical: <VerticalLayout routes={Routes} />
};

const getRoutes = () => {
  const defaultLayout = "vertical";
  const layouts = ["vertical", "blank"];
  const AllRoutes = [];

  layouts.forEach((layoutItem) => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout);
    AllRoutes.push({
      path    : "/",
      element : getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    });
  });
  return AllRoutes;
};

export { Routes, getRoutes };
